import { render, staticRenderFns } from "./ModalCancelDelivery.vue?vue&type=template&id=22a2ed28&scoped=true&"
import script from "./ModalCancelDelivery.vue?vue&type=script&lang=ts&"
export * from "./ModalCancelDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCancelDelivery.vue?vue&type=style&index=0&id=22a2ed28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a2ed28",
  null
  
)

export default component.exports